import React, { useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import ReactToPrint from 'react-to-print';
import Preview from "./Preview";
import Button from '@material-ui/core/Button';
import print from '../assets/images/print.svg'
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  }
}));

const Results = ({ dotsFirstStep, dotsSecondStep }) => {
  const { t } = useTranslation()
  const cVisible = false;
  const componentRef = useRef();
  const classes = useStyles();
  return (
    <div>
      <Preview ref={componentRef} dotsFirstStep={dotsFirstStep} dotsSecondStep={dotsSecondStep} cVisible={cVisible} />

      <ReactToPrint
        copyStyles
        trigger={() => <Button variant="contained" className={classes.button}>{t('print')} <img className="mx-1" src={print} alt="print" /></Button>}
        content={() => componentRef.current}
      />
    </div>


  );
};

export default Results;



